import { jsx as r, Fragment as n } from "react/jsx-runtime";
import { useI18n as h } from "next-localization";
import { S as c } from "./index.BhPhnmkE.js";
const g = ({
  count: i,
  end: o,
  displaySize: m = 10,
  isLoading: s,
  resultDisplayName: l,
  start: a,
  className: $
}) => {
  const { t: e } = h();
  if (s)
    return /* @__PURE__ */ r(c, { height: 20, width: 200 });
  const t = l ?? `${e("Search.Result.Articles")}`;
  return /* @__PURE__ */ r("div", { className: $, children: i <= Number(m) ? /* @__PURE__ */ r(n, { children: `${e("Search.Result.DisplayingAll")} ${e("Common.Of")} ${i} ${t}` }) : /* @__PURE__ */ r(n, { children: `${e("Search.Displaying")} ${a}-${o} ${e("Common.Of")} ${i} ${t}` }) });
};
export {
  g as P
};
